import { render } from "./sponser.vue?vue&type=template&id=a03f4f28&scoped=true"
import script from "./sponser.vue?vue&type=script&lang=js"
export * from "./sponser.vue?vue&type=script&lang=js"

import "./sponser.vue?vue&type=style&index=0&id=a03f4f28&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03f4f28"]])

export default __exports__